import colors from 'tailwindcss/colors';

/* 
INFO: Colors imported from  https://ds.services.gov.ie/foundations/design-tokens/color/
*/
export const iotsColors = {
  emerald: {
    50: '#f0fff7',
    100: '#c2fde1',
    200: '#95fbd0',
    300: '#4aecb4',
    400: '#19d39f',
    500: '#00b089',
    600: '#008971',
    700: '#006658',
    800: '#004d44',
    900: '#003630',
    950: '#00241e',
  },
  gold: {
    50: '#fffbf2',
    100: '#f4edde',
    200: '#e9dfcb',
    300: '#d1c3a3',
    400: '#baa980',
    500: '#a39161',
    600: '#8a7742',
    700: '#715f28',
    800: '#584915',
    900: '#3f3308',
    950: '#261f00',
  },
  grey: {
    50: '#f7f7f8',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
    950: '#0a0e16',
  },
  red: {
    50: '#fff4f2',
    100: '#fdd1ca',
    200: '#faafa3',
    300: '#f27764',
    400: '#e65038',
    500: '#d4351c',
    600: '#bb250d',
    700: '#9a1a04',
    800: '#741201',
    900: '#4c0b00',
    950: '#290600',
  },
};

export const iotsBrandColors = {
  faint: iotsColors.emerald[50],
  muted: iotsColors.emerald[200],
  subtle: iotsColors.emerald[400],
  DEFAULT: iotsColors.emerald[800],
  emphasis: iotsColors.emerald[950],
  inverted: colors.white,
};

export const darkIotsBrandColors = {
  faint: '#001311',
  muted: '#092a26',
  subtle: '#063732',
  DEFAULT: iotsColors.emerald[800],
  emphasis: '#007568',
  inverted: colors.black,
};

export const iotsLightGrey = '#edece5';
export const iotsLightGreyHover = '#e2e4de';

export const iotsBoxShadow = '0px 4px 4px 0px rgba(0, 0, 0, 0.25)';
